import { Button, Tooltip } from "@deligoo/ui"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { shallowEqual } from "react-redux"

import { useAppDispatch, useAppSelector } from "@/App"
import { DefList, DefListItem } from "@/components/DefList"
import { clearDeliveryZone, getClientDeliveryZone, selectClientById, selectClientDeliveryZone } from "@/store/clients"
import { Client } from "@/types"
import { signInPOS } from "@/utils"

import cls from "./AboutClient.module.scss"

type AboutClientProps = {
  id: Client["id"]
  close: () => void
}

export const AboutClient = ({ id, close }: AboutClientProps) => {
  const client = useAppSelector(selectClientById(id), shallowEqual)
  const clientDeliveryZone = useAppSelector(selectClientDeliveryZone, shallowEqual)

  const dispatch = useAppDispatch()

  const { t } = useTranslation()

  useEffect(() => {
    return () => {
      if (clientDeliveryZone) dispatch(clearDeliveryZone())
    }
  }, [dispatch, clientDeliveryZone])

  if (!client) return null

  return (
    <div className={cls.panel}>
      <header className={cls.header}>
        <h2 className={cls.title}>
          {t("restaurant")} {client.name}
        </h2>
        <Button onClick={close} variation="outlined" color="primary" iconProps={{ name: "close" }} />
      </header>

      <section className={cls.section}>
        <DefList inline>
          {client.partner.name && <DefListItem title={t("client")} desc={client.partner.name} icon="business-client" />}
          <DefListItem title={t("phone")} desc={client.phone} icon="phone" />
          <DefListItem title={t("address")} desc={client.address} icon="map-layers" />
        </DefList>
      </section>

      <section className={cls.section}>
        <DefList inline>
          <DefListItem title={t("distance_limit")} desc={`${client.deligoo_max_distance_limit}km`} />
          <DefListItem
            title={t("order_management_kind")}
            desc={t(`order_management.${client.order_management_kind}`)}
          />
          <DefListItem title="Aktywność obszaru" desc={client.settings.use_geofences ? "Włączony" : "Wyłączony"} />
        </DefList>

        <div className={cls.buttons}>
          {client.settings.geofences_pos_id ? (
            <Button
              variation="solid"
              color="primary"
              iconProps={{ name: "map-view" }}
              onClick={() =>
                clientDeliveryZone ? dispatch(clearDeliveryZone()) : dispatch(getClientDeliveryZone(client.id))
              }
            >
              {clientDeliveryZone ? "Ukryj obszar" : "Pokaż obszar"}
            </Button>
          ) : (
            <Tooltip content="Brak obszaru dedykowanego">
              <span>
                <Button fullWidth variation="solid" iconProps={{ name: "map-view" }} disabled>
                  Pokaż obszar
                </Button>
              </span>
            </Tooltip>
          )}
          <Button
            variation="solid"
            color="primary"
            iconProps={{ name: "business-client" }}
            onClick={() => signInPOS(id)}
          >
            {t("log_in_to_panel")}
          </Button>
        </div>
      </section>
    </div>
  )
}
